export default "__VITE_ASSET__P4Pvjg9S__"